// ============================================
// top Map
// ============================================

function topMap() {
  const hover = document.querySelector(".js-hover-map");
  if (hover) {
    const img = hover.querySelectorAll(".js-hover-map__img");
    const trigger = document.querySelectorAll(".js-hover-map__trigger");

    trigger.forEach((target, index) => {
      target.addEventListener("mouseenter", () => {
        console.log(index);
        img.forEach((img_item) => {
          img_item.classList.remove("-current");
        });
        img[index].classList.add("-current");
      });
    });
  }
}

export { topMap };
